import type { ViewportToolsetId } from "@/viewport-tools/core/contracts";
import type {
  ViewportToolsetRailController,
  ViewportToolsetRailRendererResult,
} from "@/viewport-tools/rail/types";

import { getViewportToolsetRailPlugin } from "@/viewport-tools/rail/plugins";
import type { ViewportToolsetRailControllerMap } from "@/viewport-tools/rail/types";

export function renderViewportToolsetRail(
  toolsetId: ViewportToolsetId,
  controller: ViewportToolsetRailController
): ViewportToolsetRailRendererResult | null {
  const plugin = getViewportToolsetRailPlugin(toolsetId);
  if (!plugin || !plugin.isController(controller)) {
    return null;
  }
  return plugin.render(controller);
}

export function collectViewportToolsetRailRendererResults(
  enabledToolsets: ViewportToolsetId[],
  controllers: ViewportToolsetRailControllerMap
): ViewportToolsetRailRendererResult[] {
  const uniqueEnabledToolsets = Array.from(new Set(enabledToolsets));

  return uniqueEnabledToolsets.flatMap((toolsetId) => {
    const controller = controllers[toolsetId];
    if (!controller) {
      return [];
    }

    const result = renderViewportToolsetRail(toolsetId, controller);
    return result ? [result] : [];
  });
}
